import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Progress } from "../ui/progress";
import VitalForm1 from "./vitalForm1";
import VitalForm2 from "./vitalForm2";
import VitalForm3 from "./vitalForm3";
import VitalForm4 from "./vitalForm4";

const AddVitals = () => {
  let navigate = useNavigate();

  const INITIAL_STEP = "step_1";
  const steps = ["step_1", "step_2", "step_3", "step_4"];
  const [currentStep, setCurrentStep] = useState(INITIAL_STEP);
  const currentStepIndex = steps.indexOf(currentStep);
  const headers = [
    {
      title: "Please tell us your height and weight",
      subtitle:
        "Many diseases only affect certain age groups. Knowing your height and weight properly allows us to provide a more accurate result.",
    },
    {
      title: "Please tell us your Pulse and respiratory rate",
      subtitle:
        "Many diseases only affect certain age groups. Knowing your pulse and respiratory rate properly allows us to provide a more accurate result.",
    },
    {
      title: "Please tell us your Temperature and Systolic/ Diastolic",
      subtitle:
        "Many diseases only affect certain age groups. Knowing your temperature rate and systolic and diastolic properly allows us to provide a more accurate result.",
    },
    {
      title: "Please tell us your Blood Sugar Level and Sp02",
      subtitle:
        "Many diseases only affect certain age groups. Knowing your blood sugar level and Sp02 properly allows us to provide a more accurate result.",
    },
  ];

  const goToIndex = (index) => {
    const newStep = steps[index];
    console.log(index, newStep);
    if (newStep) {
      setCurrentStep(newStep);
    } else {
      navigate("/vitalSummary");
    }
  };
const back = () => {
  sessionStorage.removeItem('form1');
  sessionStorage.removeItem('form2');
  sessionStorage.removeItem('form3');
  navigate('/dashboard');
}

  return (
    <div className="bg-gray-50 min-sh-screen">
      <div className="flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 ">
        <div>
          <button className="flex" onClick={back}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            <div className="pl-2 flex-1 mt-0.5">
              <h4 className="font-semibold text-sm">Vital Information</h4>
            </div>
          </button>
        </div>
      </div>

      <div className=" flex-1 overflow-scroll hideScroll  text-gray-500flex flex-col pt-16 p-4">
        <div className=" h-2 bg-gray-200 rounded-lg">
          <Progress value={((currentStepIndex + 1) / steps.length) * 100} />
        </div>
        <div className="text-blue-800 text-[25px] font-extrabold font-['SF Pro Display'] uppercase my-3 mt-14">
          Add Your Vitals
        </div>
        {currentStep === "step_1" && (
          <>
            <div className="text-black text-[20px] font-semibold font-['SF Pro Display']">
              {headers[currentStepIndex].title}
            </div>
            <div className="x] text-black text-[15px] font-normal font-['SF Pro Display']">
              {headers[currentStepIndex].subtitle}
            </div>
            <div className="pt-5">
              <VitalForm1 nextStep={() => goToIndex(1)}></VitalForm1>
            </div>
          </>
        )}

        {currentStep === "step_2" && (
          <>
            <div className="text-black text-[20px] font-semibold font-['SF Pro Display']">
              {headers[currentStepIndex].title}
            </div>
            <div className="x] text-black text-[15px] font-normal font-['SF Pro Display']">
              {headers[currentStepIndex].subtitle}
            </div>
            <div>
              <VitalForm2 nextStep={() => goToIndex(2)}></VitalForm2>
            </div>
          </>
        )}
        {currentStep === "step_3" && (
          <>
            <div className="text-black text-[20px] font-semibold font-['SF Pro Display']">
              {headers[currentStepIndex].title}
            </div>
            <div className="x] text-black text-[15px] font-normal font-['SF Pro Display']">
              {headers[currentStepIndex].subtitle}
            </div>
            <div>
              <VitalForm3 nextStep={() => goToIndex(3)}></VitalForm3>
            </div>
          </>
        )}
        {currentStep === "step_4" && (
          <>
            <div className="text-black text-[20px] font-semibold font-['SF Pro Display']">
              {headers[currentStepIndex].title}
            </div>
            <div className="x] text-black text-[15px] font-normal font-['SF Pro Display']">
              {headers[currentStepIndex].subtitle}
            </div>
            <div>
              <VitalForm4 nextStep={() => goToIndex(4)}></VitalForm4>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddVitals;
